import React, { type ReactElement, type ReactNodeArray } from "react";
import { FormattedMessage } from "react-intl";
import DispatchTimezoneEnum from "src/dispatches/objects/DispatchTimezoneEnum";

export interface IDispatchTimezoneFormatterProps {
  children: DispatchTimezoneEnum;
  toStringHandler?: (nodes: ReactNodeArray) => ReactElement;
}
export const DispatchTimezone = ({
  toStringHandler,
  children,
}: IDispatchTimezoneFormatterProps) => {
  switch (children) {
    case DispatchTimezoneEnum.SUBSCRIBER_TIMEZONE:
      return (
        <FormattedMessage id="dispatches.timezone.subscriber">
          {toStringHandler}
        </FormattedMessage>
      );
    case DispatchTimezoneEnum.STORE_TIMEZONE:
      return (
        <FormattedMessage id="dispatches.timezone.store">
          {toStringHandler}
        </FormattedMessage>
      );
    case DispatchTimezoneEnum.USER_TIMEZONE:
      return (
        <FormattedMessage id="dispatches.timezone.user">
          {toStringHandler}
        </FormattedMessage>
      );
    default:
      return <FormattedMessage id="ui.na">{toStringHandler}</FormattedMessage>;
  }
};
